<template>
  <a id="profile-button" href="/userProfile" :aria-label="$t('message.userProfileLabel')">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" :fill="theme === 'light' ? '#FFFFFF' : '#000000'" aria-hidden="true">
      <path id="userProfileIcon" d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"/>
      <path d="M0 0h24v24H0z" fill="none"/>
    </svg>
  </a>
</template>
<script>
  import Vue from 'vue'
  import VueI18n from 'vue-i18n'

  const messages = {
    en: {
      message: {
        userProfileLabel: 'Link to User profile'
      }
    },
    hi: {
      message: {
        userProfileLabel: 'उपयोगकर्ता प्रोफ़ाइल'
      }
    }
  }

  Vue.use(VueI18n)

  const i18n = new VueI18n({
    locale: typeof (Storage) !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en',
    messages: messages
  })

  export default {
    i18n,
    data () {
      return {
        lang: typeof (Storage) !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en'
      }
    },
    props: {
      theme: {
        type: String,
        required: true,
        default: 'dark'
      },
      userLang: {
        type: String,
        default: 'en'
      }
    },
    watch: {
      userLang: function (newVal) {
        i18n.locale = newVal
      }
    }
  }
</script>

<style scoped>
  #profile-button {
    padding: 5px;
    border-radius: 50%;
    background-color: transparent;
    border: none;
    margin-right: 1em;
  }

  #profile-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
    cursor: pointer;
  }

  #profile-button:focus {
    background-color: rgba(255, 255, 255, 0.1);
  }
</style>


// WEBPACK FOOTER //
// src/components/ProfileLink.vue